// @ts-ignore

import { useIntl } from "react-intl";

import { useLocalizedHref } from "@/libraries/web-framework";
import { DropdownContent } from "@/patterns/global-nav/src/dropdown-content";

export const FeaturesDropdown = () => {
    const intl = useIntl();

    const allFeaturesLink = {
        text: intl.formatMessage({
            id: "jira.FeaturesDropdown.allFeatures",
            defaultMessage: "All Features"
        }),
        href: useLocalizedHref("/software/jira/features")
    };

    const featureLinks = [
        {
            text: intl.formatMessage({
                id: "jira.FeaturesDropdown.rovo",
                defaultMessage: "Rovo in Jira"
            }),
            href: useLocalizedHref("/software/jira/ai")
        }
    ];

    return (
        <DropdownContent
            orientation="column"
            contentSections={[
                {
                    links: [allFeaturesLink, ...featureLinks]
                }
            ]}
        />
    );
};
